export const Meals = Object.freeze({
  NO: {
    key: 'D',
    value: 'No Food',
  },
  VEG: {
    key: 'V',
    value: 'Veg Food',
  },
  NON_VEG: {
    key: 'N',
    value: 'Non Veg Food',
  },
});

export const getMealPreferenceOptions = () => Object.values(Meals).map((meal) => ({
  id: meal.key,
  text: meal.value,
  obj: meal,
}));

export const getMealOptions = (values) =>
  getMealPreferenceOptions().filter((meal) => values.includes(meal.id));

export const DEFAULT_FOOD_TYPE = {
  key: 'D',
  value: 'No Food',
};

export const getApplicableFoodTypes = (applicableFoodTypes) => {
  return applicableFoodTypes
    ? Object.entries(applicableFoodTypes).map(([key, value]) => ({
        id: key,
        text: value,
        obj: {
          key: key,
          value: value,
        },
      }))
    : [];
};
